export function initCurrency(root, state, endpoint) {
    const amounts = [...root.querySelectorAll('[data-money-amount]')];
    const buttons = [...root.querySelectorAll('[data-chalet-currency]')];
    const status = root.querySelector('[data-currency-status]');
    const rates = new Map();
    let requestId = 0;
    let previousCurrency = null;
    const format = new Intl.NumberFormat('en-US');
    async function rate(from, to) {
        if (from === to) return 1;
        const key = `${from}:${to}`;
        if (!rates.has(key)) {
            rates.set(key, fetch(`${endpoint}?${new URLSearchParams({from, to})}`, {headers: {Accept: 'application/json'}})
                .then(async response => {
                    const body = await response.json();
                    if (!response.ok || !(body.rate > 0)) throw new Error('Currency conversion unavailable');
                    return Number(body.rate);
                }).catch(error => { rates.delete(key); throw error; }));
        }
        return rates.get(key);
    }
    state.subscribe(async ({currency}) => {
        if (!currency || currency === previousCurrency) return;
        previousCurrency = currency;
        const currentRequest = ++requestId;
        status.textContent = 'Updating currency…';
        try {
            const converted = await Promise.all(amounts.map(async element => ({
                element,
                amount: Math.round(Number(element.dataset.moneyAmount) * await rate(element.dataset.moneyCurrency, currency)),
            })));
            if (currentRequest !== requestId) return;
            converted.forEach(({element, amount}) => { element.textContent = `${format.format(amount)} ${currency}`; });
            buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.chaletCurrency === currency)));
            status.textContent = '';
        } catch (_) {
            if (currentRequest !== requestId) return;
            previousCurrency = null;
            status.textContent = 'Currency conversion is unavailable. Prices remain in the displayed currency.';
        }
    });
    buttons.forEach(button => button.addEventListener('click', () => state.set({currency: button.dataset.chaletCurrency})));
}
